const modules = import.meta.glob('./pages/**/*.js', { eager: true });

const localeMap = {};
// 遍历所有组件模块并自动引入，嵌套目录以下划线拼接作为key来使用。如产品目录，是 product_product.title这样
for (const [path, module] of Object.entries(modules)) {
  const key = path
    .replace(/^\.\/pages\//, '')
    .replace(/\//g, '_')
    .replace(/\.js$/, '');
  if (key) {
    localeMap[key] = module.default;
  }
}

export default localeMap;
